import { Routes as RouterRoutes, Route } from "react-router";
import { Home } from "@/features/Home";
import { Layout } from "@/features/shell/Layout";
import { GradingContainer } from "@/features/grading/GradingContainer";
import { PdfViewer } from "@/features/reader/PdfViewer";
import { ReaderContainer } from "@/features/reader/ReaderContainer";
import { RubricBoard } from "@/features/rubric/RubricBoard";
import { Login } from "./features/accounts/Login";
import { LtiLaunch } from "./features/accounts/LtiLaunch";

export const Routes = () => {
  return (
    <RouterRoutes>
      {/* Accounts */}
      <Route
        path="/signin"
        element={
          <div className="h-screen overflow-hidden bg-[#FFFEFD]">
            <Login />
          </div>
        }
      />
      <Route
        path="/lti/callback"
        element={
          <div className="h-screen overflow-hidden bg-[#FFFEFD]">
            <LtiLaunch />
          </div>
        }
      />

      {/* Document routes with shared layout */}
      <Route
        path="/documents/:documentId"
        element={
          <Layout>
            <ReaderContainer />
          </Layout>
        }
      />

      <Route
        path="/documents/:documentId/pdf"
        element={
          <Layout>
            <PdfViewer />
          </Layout>
        }
      />

      <Route
        path="/documents/:documentId/rubric"
        element={
          <Layout>
            <RubricBoard />
          </Layout>
        }
      />

      <Route
        path="/documents/:documentId/grading"
        element={
          <Layout>
            <GradingContainer />
          </Layout>
        }
      />

      {/* Home with nested routes - catch all other paths */}
      <Route
        path="*"
        element={
          <div className="h-screen overflow-hidden bg-[#FFFEFD]">
            <Home />
          </div>
        }
      />
    </RouterRoutes>
  );
};
